import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";

class DocumentRecordDetail extends Component {
  state = {
    pageTitle: "Müşteriden İstenen Belgeler/ÜTS Belge Kayıt Detay",
    pageTitleDetail: "Müşteriden İstenen Belgeler/ÜTS Belge Kayıt Detay",
    pageAddLink: "musteri-belge-talep-ekle",
    pageListLink: "musteri-belge-talep-listele",
    breadcrumb: [{ text: "Müşteriden İstenen Belgeler/ÜTS Belge Kayıt", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    customerName: "",
    status: "",
    offerDate: "",
    statusMail: "",
    offerTotal: "",
    currencyType: "",
    requestedDocumentsName: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        //pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/documentRecords/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            customerName: response.data.customerName,
            requestedDocumentsName: response.data.requestedDocumentsName,
            offerTotal: response.data.offerTotal,
            offerDate: response.data.offerDate,
            currencyType: response.data.currencyType,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            statusMail: response.data.statusMail,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  name="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Müşteri</th>
                    <th className="colon">:</th>
                    <td colSpan="4">
                      {this.state.customerName ? this.state.customerName : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Teklif Bilgileri</th>
                    <th className="colon">:</th>
                    <td colSpan="4">
                      {this.state.offerDate + "-" + this.state.offerTotal + " " + (this.state.currencyType === 1 ? "TL" : this.state.currencyType === 2 ? "$" : 
                      this.state.currencyType === 3 ? "€" : "")} 
                    </td> 
                  </tr>
               <tr>
                  <th>Belgeler</th>
                    <th className="colon">:</th>
                    <td colSpan="4">
                      {this.state.requestedDocumentsName}
                    </td>
                  </tr>

                  <tr>
                    <th>E-mail Durumu</th>
                    <th className="colon">:</th>
                    <td colSpan="4">{this.state.statusMail === 1 ? "E-mail Gönderilsin" : "E-mail Gönderilmesin !"}</td>
                  </tr>

                  <tr>
                    <th>Durum</th>
                    <th className="colon">:</th>
                    <td colSpan="4">{this.state.status ? "Aktif" : "Pasif"}</td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <th className="colon">:</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <th className="colon">:</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <th className="colon">:</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <th className="colon">:</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default DocumentRecordDetail;
